/* eslint-disable no-unused-vars */
import { Button, CircularProgress, Grid } from "@mui/material";
import { BUILD_NUMBER } from "../../build";
import PDialog from "../../components/pos/PDialog";
import PSelect from "../../components/pos/PSelect";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { PrintUtils } from "../../utils/PrintUtils";
import PRSelect from "../../components/pos/PRSelect";

import axios from "axios";

export default function TerminalConfig(props) {
  const { t } = useTranslation();
  const translate = t;

  const [printingModeOptions, setPrintingModeOptions] = useState([
    { value: "LOCAL", label: "Local" },
    { value: "CLOUD_PRINT", label: "Cloud Print Service" },
  ]);

  const [printingMode, setPrintingMode] = useState();
  const [printerOptions, setPrinterOptions] = useState([]);

  useEffect(() => {
    if (localStorage.getItem("w_barcode_Printing_mode")) {
      setPrintingMode(
        JSON.parse(localStorage.getItem("w_barcode_Printing_mode"))
      );
    }
  }, []);

  useEffect(() => {
    if (printingMode && printingMode.value === "CLOUD_PRINT") {
      refreshCloudPrinters();
    }
    if (printingMode && printingMode.value === "LOCAL") {
      refreshLocalPrinters();
    }
  }, [printingMode]);

  const [barcodePrinter, setBarcodePrinter] = useState(null);
  const [shelfLabelPrinter, setShelfLabelPrinter] = useState(null);

  function onCloseWindow() {
    props.setShowTerminalConfig(false);
  }

  async function refreshCloudPrinters() {
    try {
      setBarcodePrinter(null);
      setShelfLabelPrinter(null);

      console.log("#### refreshCloudPrinters");
      props.showProgress(translate("Checking Cloud Printers..."));
      let otherPrinters = [];

      let comports = [];

      let [url, token] = await PrintUtils.getCloudPrintToken();
      const config = {
        headers: { Authorization: `Bearer ${token}` },
      };
      let devices = await axios.get(
        "/cloudprintbackend/api/v1/core/devices",
        config
      );

      console.log(devices);
      for (let device of devices.data) {
        console.log(device);
        if (device.deviceFamily === "PRINTER") {
          otherPrinters.push({
            value: device.id,
            label: device.name,
          });
          if (localStorage.getItem("w_barcodePrinter")) {
            setBarcodePrinter(
              JSON.parse(localStorage.getItem("w_barcodePrinter"))
            );
          }
          if (localStorage.getItem("w_shelfLabelPrinter")) {
            setShelfLabelPrinter(
              JSON.parse(localStorage.getItem("w_barcodePrinter"))
            );
          }
        }
      }
      setPrinterOptions(otherPrinters);

      props.hideProgress();
    } catch (err) {
      console.log(err);
      props.hideProgress();
    }
  }

  async function refreshLocalPrinters() {
    setBarcodePrinter(null);
    setShelfLabelPrinter(null);
    try {
      console.log("#### refreshCloudPrinters");
      props.showProgress(translate("Checking Local Printers..."));
      let otherPrinters = [];

      let devices = await axios.get(
        "http://localhost:3337/agent/device/printers"
      );

      for (let device of devices.data) {
        console.log(device);
        otherPrinters.push({
          value: device.id,
          label: device.name,
        });
        if (localStorage.getItem("w_barcodePrinter")) {
          setBarcodePrinter(
            JSON.parse(localStorage.getItem("w_barcodePrinter"))
          );
        }
        if (localStorage.getItem("w_shelfLabelPrinter")) {
          setShelfLabelPrinter(
            JSON.parse(localStorage.getItem("w_shelfLabelPrinter"))
          );
        }
      }
      setPrinterOptions(otherPrinters);

      props.hideProgress();
    } catch (err) {
      console.log(err);
      props.hideProgress();
    }
  }

  function handleSave() {
    if (printingMode && printingMode.value) {
      localStorage.setItem(
        "w_barcode_Printing_mode",
        JSON.stringify(printingMode)
      );
      if (barcodePrinter && barcodePrinter.value) {
        localStorage.setItem(
          "w_barcodePrinter",
          JSON.stringify(barcodePrinter)
        );
      } else {
        localStorage.removeItem("w_barcodePrinter");
      }
      if (shelfLabelPrinter && shelfLabelPrinter.value) {
        localStorage.setItem(
          "w_shelfLabelPrinter",
          JSON.stringify(shelfLabelPrinter)
        );
      } else {
        localStorage.removeItem("w_shelfLabelPrinter");
      }
    } else {
      localStorage.removeItem("w_barcode_Printing_mode");
      localStorage.removeItem("w_barcodePrinter");
      localStorage.removeItem("w_shelfLabelPrinter");
    }
    props.showMessage("success", translate("Settings Saved"));
    onCloseWindow();
  }

  return (
    <div>
      <PDialog
        onSave={handleSave}
        saveLabel={"Save"}
        content={
          <Grid container>
            <Grid item xs={12}>
              {translate("Printing Mode")}
            </Grid>
            <Grid item xs={12}>
              <PRSelect
                options={printingModeOptions}
                onChange={(e) => {
                  setPrintingMode(e);
                }}
                value={printingMode}
              ></PRSelect>
            </Grid>

            <Grid item xs={12}>
              {translate("Barcode Printer")}
            </Grid>

            <Grid item xs={12}>
              <PRSelect
                options={printerOptions}
                onChange={(e) => {
                  setBarcodePrinter(e);
                }}
                value={barcodePrinter}
              ></PRSelect>
            </Grid>

            <Grid item xs={6}>
              {translate("Shelf Label Printer")}
            </Grid>

            <Grid item xs={12}>
              <PRSelect
                options={printerOptions}
                onChange={(e) => {
                  console.log(e);
                  setShelfLabelPrinter(e);
                }}
                value={shelfLabelPrinter}
              ></PRSelect>
            </Grid>
          </Grid>
        }
        title={"Printer Configuration"}
        maxWidth={"sm"}
        fullWidth={true}
        open={true}
        onCloseWindow={onCloseWindow}
        mode="create"
      ></PDialog>
    </div>
  );
}
